import styled from 'styled-components';
import { EMAIL } from 'constants/messageMediums';
import { MediumContent, EmailContentDefinition } from 'modules/graphql/types/GraphQLTemplate';
import { EmailPreviewSubject } from './EmailPreviewSubject';
import { TemplatePreview } from './TemplatePreview';
import { ScrollArea } from 'ui/scrollArea';

export const EmailPreviewContent = styled(ScrollArea)`
  border-radius: 0;
`;

type EmailPreviewProps = {
  templateId: number;
  templateData: MediumContent;
  isTemplateDataLoading: boolean;
};

export const EmailPreview = ({
  templateId,
  templateData,
  isTemplateDataLoading,
}: EmailPreviewProps) => {
  return (
    <>
      <EmailPreviewSubject
        templateData={templateData as EmailContentDefinition}
        isTemplateDataLoading={isTemplateDataLoading}
      />
      <EmailPreviewContent type="hover" height={'450px'} width={'100%'}>
        <TemplatePreview messageMedium={EMAIL} templateId={templateId} />
      </EmailPreviewContent>
    </>
  );
};
